import React, { ComponentProps } from "react";

function BarChartIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={16}
      height={12}
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="chart.bar.fill">
        <g id="Group">
          <path
            id="Vector"
            d="M1.33898 11.5297H3.00222C3.87726 11.5297 4.34706 11.0787 4.34706 10.2468V5.20793C4.34706 4.37602 3.87726 3.92017 3.00222 3.92017H1.33898C0.469802 3.92017 0 4.37602 0 5.21004V10.2468C0 11.0787 0.469802 11.5297 1.33898 11.5297Z"
          />
          <path
            id="Vector_2"
            d="M6.75013 11.5297H8.41818C9.29323 11.5297 9.75818 11.0787 9.75818 10.2468V3.49651C9.75818 2.6646 9.29323 2.20874 8.41818 2.20874H6.75013C5.88093 2.20874 5.41113 2.6646 5.41113 3.49862V10.2468C5.41113 11.0787 5.88093 11.5297 6.75013 11.5297Z"
          />
          <path
            id="Vector_3"
            d="M12.1609 11.5298H13.8289C14.7029 11.5298 15.1727 11.0787 15.1727 10.2469V1.78777C15.1727 0.955857 14.7029 0.5 13.8289 0.5H12.1609C11.2965 0.5 10.8267 0.955857 10.8267 1.78883V10.2469C10.8267 11.0787 11.2965 11.5298 12.1609 11.5298Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default BarChartIcon;
